module.exports = __webpack_public_path__ + "51f5ee8c8f6eba459d69b13281b2c516.fbx";